module.exports = __webpack_public_path__ + "static/media/14.e268bd2b.png";